import { LogMeta, Severity } from './types';

const isDev =
  process.env.NODE_ENV !== 'production' ||
  localStorage.getItem('telemetry_debug') === '1';

export const logToConsole = (props: {
  severity: Severity;
  message: string;
  extra?: LogMeta;
}) => {
  if (!isDev) return;
  const { severity, message, extra } = props;
  const payload = { ...extra };
  const msg = `[telemetry] ${severity} ${message}`;
  if (severity === 'ERROR') {
    console.error(msg, payload);
  } else if (severity === 'WARNING') {
    console.warn(msg, payload);
  } else if (severity === 'DEBUG') {
    console.debug(msg, payload);
  } else {
    console.info(msg, payload);
  }
};
